// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3t3BE","validationTips":"StatementDescriptor_validationTips__3qADZ"};